import React, { useEffect } from "react";
import { BrowserRouter, Routes, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "./redux/userSlice";
import AppBootstrap from './AppBootstrap';
// Admin routes
import AuthRoutes from "./routes/authRoutes";
import AdminRoutes from "./routes/adminRoutes";

const lazyInitMetronic = () => {
  setTimeout(() => {
    if ((window as any).KTComponents) {
      (window as any).KTComponents.init();
      (window as any).KTDrawer?.init();
      (window as any).KTMenu?.init();
      (window as any).KTScroll?.init();
      (window as any).KTSticky?.init();
      (window as any).KTSwapper?.init();
      (window as any).KTToggle?.init();
      (window as any).KTScrolltop?.init();
      (window as any).KTDialer?.init();
      (window as any).KTImageInput?.init();
      (window as any).KTPasswordMeter?.init();
    }
  }, 300);
};

// Hook to reinitialize Metronic on navigation
const useMetronicInit = () => {
  const location = useLocation();

  // 🔹 Run ONCE on app mount
  useEffect(() => {
    lazyInitMetronic();
  }, []);

  // 🔹 On route change: only resize / layout refresh
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, [location.pathname]);
};


function App() {
  return (
    <BrowserRouter>
      <AppBootstrap />
      <MetronicWrapper />
    </BrowserRouter>
  );
}

// Wrapper component to use `useLocation` inside BrowserRouter
const MetronicWrapper: React.FC = () => {
  useMetronicInit(); // Initialize Metronic on navigation

  return (
    <div>
      <Routes>
        {/* Public Routes */}
        {/*PublicRoutes()*/}
        {/* Auth Routes */}
        {AuthRoutes()}
        {/* Admin Routes */}
        {AdminRoutes()}
      </Routes>
    </div>
  );
};

export default App;
